import Vue from 'vue';
import { reduxStorePlugin } from 'redux-vue';
import VueRouter from 'vue-router';
import Fragment from 'vue-fragment';
import App from './App';
import {store} from './configureStore';
import {router} from './router';
import i18n from './i18n';
import PortalVue from 'portal-vue';
/* import VueGtag from "vue-gtag"; */

import './helpers/screens';
import './assets/tailwind.css';
import './assets/css/style.css';

 
// If google analytics are needed, uncomment the following lines and replace XXXXXX with the tracking id
/*
Vue.use(VueGtag, {
  config: { id: "XXXXXX" }
}, router);
*/

Vue.config.productionTip = false;

Vue.use(reduxStorePlugin);
Vue.use(VueRouter);
Vue.use(Fragment.Plugin);
Vue.use(PortalVue);

/* eslint-disable no-new */
new Vue({
  i18n,
  store,
  router,
  render: h => h(App)
}).$mount('#app');
